export const URL_PREFIX = {
  PROD: import.meta.env.VITE_API_BASE_PATH,
};

export const customBaseUrl = URL_PREFIX.PROD;
